import React, { useState, useEffect } from "react"

import { Paper, TableRow, TableCell, Grid, Divider } from "@material-ui/core"

import { stableSort, getComparator } from "App/Component/ui/datatable/utils"

import {
  DatatablesFooterServerSide,
  ModalDeleteConfirm,
  Title,
  TableCellDefault,
  Loading,
  MasterButton,
  TableAction,
} from "App/Component/ui"

import { STYLE_DEFAULT_MASTER } from "App/constants/theme"

import { useDatatablesServerSide, useDatatables } from "App/hooks"
import {
  deletePembelianById,
  getByFilterPembelian,
  getDataPembelian,
  headCells,
  ListTotalPembelianFetch,
  RenderStatusPembelianBadge,
  RESET_STATE_FORM_FILTER,
  STATE_PEMBELIAN_TERPOSES,
} from "./helpers"
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers"

import { WMS_PBF_PEMBELIAN } from "App/constants"
import FormFilterDaftarPembelian from "./FormFilterDaftarPembelian"
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
} from "../PembelianWMS/helpers"
import ListTotalPembelian from "./ListTotalPembelian"
import { FreezeTable } from "components/organism"
import ModalKonfirmasiHapusPembelian from "./ModalKonfirmasiHapusPembelian"

export default function DaftarPembelian({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER()
  const [pembelianID, setPembelianID] = useState(null)
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [showModalHapus, setShowModalHapus] = useState(false)
  const [formData, setFormData] = useState(STATE_PEMBELIAN_TERPOSES)
  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeParentData("")
        changeMenu(WMS_PBF_PEMBELIAN)
      })
      .then(async () => {
        setPembelianID(row.id)
        await changeParentData({
          id: row?.id,
          idgl: row.idgl,
          date: defaultDateInputDisplay(row?.date),
          is_po: row?.is_po,
          po_id: row?.po_id,
          po_label: "Cari PO",
          gudang_id: row.gudang_id,
          gudang: row.nama_gudang,
          user: row.user,
          supplier_id: row.supplier_id,
          supplier: row.nama_supplier,
          faktur_no: row.faktur_no,
          faktur_tgl: defaultDateInputDisplay(row?.faktur_tgl),
          jatuhtempo_tgl: defaultDateInputDisplay(row?.jatuhtempo_tgl),
          kedatangan_tgl: defaultDateInputDisplay(row?.kedatangan_tgl),
          tagih_tgl: defaultDateInputDisplay(row?.tagih_tgl),
          kasbank_id: row.kasbank_id,
          kasbank: row.namaKasBank,
          status: row.status,
          biayalain: row?.biayalain,
          biayalain2: row?.biayalain,
          ongkos: row?.ongkos,
          ongkos2: row?.ongkos,
          potongan: row?.potongan,
          potongan2: row?.potongan,
          tax: row?.tax,
          tax2: row?.tax,
          sisa: row?.sisa,
          is_changesellprice: row?.is_changesellprice,
          pembayaran: row?.bayar,
          type: "update",
          isOpenDraft: true,
          isProcess: row?.status === 1 ? false : true,
        })

        await changeTitle(WMS_PBF_PEMBELIAN)
        await changeMenu(WMS_PBF_PEMBELIAN)
        handleClickMenu({
          code: WMS_PBF_PEMBELIAN,
          name: "Pembelian",
        })
      })
  }

  const [rows, setRows] = useState([])
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)
    const res = await getByFilterPembelian(
      formFilter,
      pages,
      limit,
      formFilter.status,
    )
    const list = await ListTotalPembelianFetch(formFilter)
    setData(list)
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickDelete = (row) => {
    setPembelianID(row.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  async function deleteList() {
    const res = await deletePembelianById(pembelianID)
    if (res.state) {
      defaultToastSuccess(res.message)
      setNewData()
    } else {
      defaultToastError(res.message)
    }
    setShowModalDeleteConfirm(false)
  }

  const handleOpenHapusTransaksi = async (row) => {
    setLoading(true)
    setFormData(STATE_PEMBELIAN_TERPOSES)
    const res = await getDataPembelian(row.id)
    if (res.state) {
      const valid_data = res.data.filter((x) => x.inv_qty >= x.pemb_qty).length
      const unvalid_data = res.data.filter((x) => x.inv_qty < x.pemb_qty).length
      setFormData({
        dataBarang: res?.data,
        id_pembelian: row?.id,
        gudang: row?.nama_gudang,
        status: row?.status,
        total_pembayaran: parseInt(res.detail.total_pembayaran),
        jumlah_pembayaran: parseFloat(res.detail.jumlah_pembayaran),
        valid_data: valid_data,
        unvalid_data: unvalid_data,
        no_faktur: row?.faktur_no,
        supplier: row?.nama_supplier,
      })
      setLoading(false)
      setShowModalHapus(true)
    } else {
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Pembelian Perbekalan Farmasi"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        {showModalHapus && (
          <ModalKonfirmasiHapusPembelian
            setShowModal={() => setShowModalHapus(false)}
            formData={formData}
            setFormData={setFormData}
            setNewData={setNewData}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={6} sm={8}>
              <FormFilterDaftarPembelian
                formFilter={formFilter}
                setFormFilter={setFormFilter}
                setNewData={setNewData}
                resetPagination={resetPagination}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <ListTotalPembelian data={data} setData={setData} />
            </Grid>
          </Grid>
          <Divider />
          <br />
          <Loading show={loading} />
          <TableDaftarPembelian
            rows={rows}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
            handleOpenHapusTransaksi={handleOpenHapusTransaksi}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  )
}

export const TableDaftarPembelian = ({
  rows,
  handleClickUpdate,
  handleClickDelete,
  onlySelect = false,
  handleClickSelect,
  handleOpenHapusTransaksi,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  })

  const RenderAction = ({ row }) => {
    if (onlySelect) {
      return (
        <>
          <TableAction
            isUpdate={false}
            isDelete={false}
            isSelect={true}
            clickSelect={() => handleClickSelect(row)}
          />
        </>
      )
    } else {
      if (row.status === STATUS_SELESAI_PEMBELIAN) {
        return (
          <TableAction
            isUpdate={false}
            isDelete={true}
            isSelect={true}
            clickSelect={() => handleClickUpdate(row)}
            clickDelete={() => handleOpenHapusTransaksi(row)}
          />
        )
      } else {
        return (
          <TableAction
            clickUpdate={() => handleClickUpdate(row)}
            clickDelete={() => handleClickDelete(row)}
            isSelect={false}
          />
        )
      }
    }
  }

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        let tanggal_bayar = ""
        if (isNull(row.tanggal_bayar)) {
          tanggal_bayar = "-"
        } else {
          if (
            isNull(row.tanggal_bayar.length) ||
            row.tanggal_bayar.length === 0
          ) {
            tanggal_bayar = "-"
          } else {
            tanggal_bayar = (
              <>
                  {row?.tanggal_bayar
                    ?.map((item) => (<>
                      {defaultDateDisplay(item)}<br />
                      </>
                    ))}
              </>
            )
          }
        }
        return (
          <TableRow hover key={index}>
            <TableCell align="center">{index + 1}</TableCell>

            <TableCell align="center">
              <RenderAction row={row} />
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">
              {isNull(row?.po_id) ? "-" : row?.po_id}
            </TableCell>
            <TableCell align="left">{row?.idgl}</TableCell>

            <TableCell align="left">
              <RenderStatusPembelianBadge status={row.status} />
            </TableCell>
            <TableCell align="left">
              {row.status !== STATUS_OPEN_DRAFT_PEMBELIAN && row.sisa <= 0 ? (
                <MasterButton
                  style={{ borderRadius: 20 }}
                  name={"Lunas"}
                  color={"green"}
                  type="button"
                  disabled
                />
              ) : (
                <MasterButton
                  style={{ borderRadius: 20 }}
                  name={"Belum Lunas"}
                  color={"warning"}
                  type="button"
                  disabled
                />
              )}
            </TableCell>
            <TableCell align="left">{row?.faktur_no}</TableCell>

            <TableCell align="left">{row?.nama_gudang}</TableCell>
            <TableCell align="left">{row?.nama_supplier}</TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.faktur_tgl)}
            </TableCell>

            <TableCell align="left">
              {defaultDateDisplay(row?.jatuhtempo_tgl)}
            </TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.kedatangan_tgl)}
            </TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.tagih_tgl)}
            </TableCell>
            <TableCell align="left">{tanggal_bayar}</TableCell>

            <TableCell align="right">{formatNumber(row?.sub_total)}</TableCell>

            <TableCell align="right">
              {formatNumber((row.tax / 100) * (row.sub_total - row.potongan))}
            </TableCell>
            <TableCell align="right">{formatNumber(row?.potongan)}</TableCell>

            <TableCell align="right">{formatNumber(row?.biayalain)}</TableCell>
            <TableCell align="right">{formatNumber(row?.ongkos)}</TableCell>
            <TableCell align="right">{formatNumber(row?.bayar)}</TableCell>
            <TableCell align="right">{formatNumber(row?.sisa)}</TableCell>

            <TableCellDefault row={row} type="custom" />
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}
